module.exports = __webpack_public_path__ + "static/img/line.faa90a9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataBrain/line.png
// module id = cecY
// module chunks = 1